module.exports = __webpack_public_path__ + "static/sc-01.8d464336.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/runn/sc-01.png
// module id = 91
// module chunks = 88197199937824 213720915766396 252993522485760